import React, { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import { DataGridColumnsPanel } from "./DataGridColumnsPanel.js";
import { GlideGrid } from "./glide-grid/GlideGrid.js";
import { GlideGridColumnsConverter } from "./glide-grid/GlideGridColumnsConverter.js";
import { GlideGridPropsConverter } from "./glide-grid/GlideGridPropsConverter.js";
function DataGridClient({ pageSizeOptions, ...props }) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  function handlePageChange(page2) {
    setPage(page2);
  }
  function handlePageSizeChange(page2) {
    setPageSize(page2);
  }
  return /* @__PURE__ */ React.createElement(
    DataGrid,
    {
      ...props,
      mode: "client",
      paging: { page, pageSize, rowCount: props.rows?.length, pageSizeOptions },
      onPageChange: handlePageChange,
      onPageSizeChange: handlePageSizeChange
    }
  );
}
function DataGridServer(props) {
  return /* @__PURE__ */ React.createElement(DataGrid, { ...props, mode: "server" });
}
function DataGrid(props) {
  const navigate = useNavigate();
  const { formatMessage, formatNumber } = useIntl();
  const glideGridPropsConverter = useRef(new GlideGridPropsConverter());
  const glideGridColumnsConverter = useRef(new GlideGridColumnsConverter(formatMessage, formatNumber, navigate));
  const [visibleColumnNames, setVisibleColumnNames] = useState(props.configurableColumns?.visibleColumns);
  const columnsToRender = props.configurableColumns ? [...props.configurableColumns?.pinnedColumns ?? [], ...visibleColumnNames ?? []] : props.columns?.map((c) => c.field);
  useEffect(() => {
    setVisibleColumnNames(props.configurableColumns?.visibleColumns);
  }, [props.configurableColumns?.visibleColumns?.join()]);
  const sortedColumns = getSortedColumns(props.columns);
  function getSortedColumns(columns) {
    let result = columns;
    if (columnsToRender?.length) {
      const sortedFieldNames = [.../* @__PURE__ */ new Set([...columnsToRender, ...columns?.map((c) => c.field) ?? []])];
      result = sortedFieldNames.map((name) => columns?.find((c) => c.field === name))?.filter((c) => c);
    }
    return result;
  }
  function handleVisibilityUpdate(visibleColumns) {
    setVisibleColumnNames(visibleColumns);
    if (props.configurableColumns?.onVisibleColumnsChange) {
      props.configurableColumns.onVisibleColumnsChange(visibleColumns);
    }
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, props.configurableColumns ? /* @__PURE__ */ React.createElement(
    DataGridColumnsPanel,
    {
      allColumns: sortedColumns,
      visibleColumns: visibleColumnNames,
      pinnedColumnNames: props.configurableColumns.pinnedColumns,
      onColumnsVisibilityUpdate: handleVisibilityUpdate
    }
  ) : null, /* @__PURE__ */ React.createElement(
    GlideGrid,
    {
      ...glideGridPropsConverter.current.convert(props),
      columns: [...glideGridColumnsConverter.current.convert(sortedColumns, columnsToRender)]
    }
  ));
}
export {
  DataGridClient,
  DataGridServer
};
//# sourceMappingURL=DataGrid.js.map
